import React from "react";

const Blogs = () => {
  return (
    <div className="min-h-screen hero ">
      <h2 className="text-2xl lg:text-5xl font-bold">Coming Soon...</h2>
    </div>
  );
};

export default Blogs;
